export default __webpack_public_path__ + "static/media/agile-polly-logo-only.ff728525.svg";